import { render } from "./AgGridIconRender.vue?vue&type=template&id=426f93bc"
import script from "./AgGridIconRender.vue?vue&type=script&lang=js"
export * from "./AgGridIconRender.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__